import { render, staticRenderFns } from "./substances.vue?vue&type=template&id=7e31455a&scoped=true&"
import script from "./substances.vue?vue&type=script&lang=js&"
export * from "./substances.vue?vue&type=script&lang=js&"
import style0 from "./substances.vue?vue&type=style&index=0&id=7e31455a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e31455a",
  null
  
)

export default component.exports